import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { selectServiceCategories } from 'redux/selectors/services';
import { StateType } from 'types';
import { getServiceCategories, addServiceSubCategory } from 'redux/actions/services';

const mapStateToProps = (state: StateType) => ({
  categories: selectServiceCategories(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getServiceCategories,
    addServiceSubCategory,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
